module.exports = __webpack_public_path__ + "img/418105582.92d46dde.jpg";